import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { clearWatchlistEntries, getWatchlists } from "../actions";
import WatchlistsView from "./WatchlistsView";
import EntriesView from "./EntriesView";

const LPRWatchlistPanel = () => {
	const dispatch = useDispatch();
	const panelRef = useRef(null);

	const [showWatchlistEntries, setShowWatchlistEntries] = useState(false);
	const [currentWatchlist, setCurrentWatchlist] = useState(null);

	const selectWatchlist = watchlist => {
		setCurrentWatchlist(watchlist);
		setShowWatchlistEntries(true);
	};

	const onClose = () => {
		setCurrentWatchlist(null);
		dispatch(clearWatchlistEntries());
		setShowWatchlistEntries(false);
	};

	const containerStyle = {
		display: "flex",
		flexDirection: "column",
		height: "calc(100% - 48px)"
	};

	return (
		<div style={containerStyle} ref={panelRef}>
			{showWatchlistEntries ? (
				<EntriesView currentWatchlist={currentWatchlist} onClose={onClose} />
			) : (
				<WatchlistsView onSelectWatchlist={selectWatchlist} />
			)}
		</div>
	);
};

export default LPRWatchlistPanel;
